<template>
    <div class="text-field-container">
        <p class="text-field-label">{{fieldLabel}}: </p>
        <p class="text-field-value">{{fieldValue}}</p>
    </div>
</template>

<script>
    export default {
        name: "TextField",
        props: {
            label: String,
            value: String
        },
        data() {
            return {
                fieldLabel: this.label,
                fieldValue: this.value ? this.value : ''
            }
        },
        watch: {
            label(newVal) {
                this.fieldLabel = newVal;
            },
            value(newVal) {
                this.fieldValue = newVal ? newVal : '';
            }
        }
    }
</script>

<style scoped>
    .text-field-container {
        text-align: left;
        width: 100%;
    }

    .text-field-label {
        color: var(--slight-light-grey);
        font-size: 20px;
    }

    .text-field-value {
        color: var(--primary-blue);
        font-size: 22px;
    }
</style>